import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  // The filter row: search input, with the loaded-count pinned beside it.
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      flexDirection: 'column',
      gap: theme.spacing(1)
    }
  },
  filterCount: {
    flex: '0 0 auto',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'flex-end'
    }
  }
}))
